// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"820":"bb316c81c50a5d4c","1586":"6ad303354459d1c4","2888":"4e5c2df902a16daf"}[chunkId] + ".css";
};